import { oc } from '@orpc/contract';
import { listSimulatorEstimatesOutputSchema } from '../schemas/simulator.schemas.js';
/** Every saved evaluation, newest first. Public: the simulator is a testing tool with no sign-in. */
export const listSimulatorEstimatesContract = oc
    .route({
    method: 'GET',
    path: '/simulator/estimates',
    tags: ['Simulator'],
    summary: 'List the evaluations saved from the public depreciation simulator',
})
    .output(listSimulatorEstimatesOutputSchema);
//# sourceMappingURL=list-simulator-estimates.contract.js.map